import { Button } from "antd";

export default function GainButton(props) {
  return (
    <Button
      className={`${
        props.className
      } text-white bg-primary border-none font-light px-10 py-2 h-full rounded-lg flex ${
        props.center ? `items-center  mx-auto` : ``
      }`}
      onClick={props.onClick}
      htmlType={props.htmlType}
    >
      <span className="pl-2">{props.label}</span>
    </Button>
  );
}
